export const GoogleMapApiConfig = 'AIzaSyDp72No0OzEilQqRORpTSdRBkyn2pxfrgk';